import * as React from "react";
import { observer } from "mobx-react-lite";
import { Alert, Button, Spin } from "antd";
import { ArrowLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import { getErrorMessage, onError } from "src/common/onError";
import { ModalDelete } from "src/components/ModalDelete";
import { ZUid } from "src/types/zUid";
import { ColumnsSettings } from "src/components/tables/ColumnsSettings";
import { Bom2aPositionsTable } from "./Bom2aPositionsTable";
import { Bom2aPosActions } from "./Bom2aPosActions";
import { Bom2aPositionsStore } from "./Bom2aPositionsStore";
import { ZBom2a } from "../../Bom2aTypes";
import styles from "./Bom2aPositions.module.less";

type PropsBom2aPositions = {
  bom: ZBom2a;
  store: Bom2aPositionsStore;
  onClose: () => void;
  modelObjectId: ZUid | undefined;
  objectServiceId: ZUid;
};

export const Bom2aPositions: React.FC<PropsBom2aPositions> = observer(
  (props) => {
    const { bom, store, onClose, modelObjectId, objectServiceId } = props;
    React.useEffect(() => {
      store.init(bom).catch(onError);
    }, [bom]);
    const reloadPositions = () => store.load(false).catch(onError);
    return (
      <div className={styles.bomPosBox}>
        <div className={styles.bomPosHeader}>
          <div className={styles.left}>
            <Button icon={<ArrowLeftOutlined />} onClick={onClose} />
            <span className={styles.title}>{bom.name}</span>
            <ColumnsSettings store={store} />
            <Button
              icon={<DeleteOutlined />}
              danger
              disabled={!store.canDelete}
              onClick={() => store.startDelete()}
            >
              Удалить
            </Button>
            <Bom2aPosActions
              modelObjectId={modelObjectId}
              objectServiceId={objectServiceId}
              currentBomId={store.bomId}
              reloadPositions={reloadPositions}
              selectedPositions={store.selectedList}
            />
          </div>
        </div>
        <div className={styles.bomPosMain}>
          {store.buzy && (
            <div className={styles.loaderBox}>
              <Spin />
            </div>
          )}
          {store.error ? (
            <Alert showIcon type="error" {...getErrorMessage(store.error)} />
          ) : (
            <Bom2aPositionsTable store={store} />
          )}
        </div>
        <ModalDelete
          message="Удалить выбранные позиции?"
          open={!!store.deleteStatus}
          onCancel={() => store.setDeleteStatus(null)}
          onOk={() => {
            store.doDelete().catch(onError);
          }}
          waiting={store.deleteStatus === "deleting"}
        />
      </div>
    );
  },
);
